// @ts-strict-ignore
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { removeItemInLocalList } from 'store/slices/localProductsList'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { useCart } from '@/entities/cart'

import { useGetRelatedProducts } from '@/shared/lib/hooks/useGetRelatedProducts'
import { ProductType } from '@/shared/types/product'

import { TotalProductSetItem } from './components/TotalProductSetItem'

import cl from './total-product-set.module.scss'

export enum ItemTypes {
	Service = `service`,
	Accessory = `accessories`,
	Total = `total`
}

/**
 * The list of all additional elements applied to current product
 */
export const TotalProductSet = ({ hidePrice = false }): JSX.Element => {
	const dispatch = useDispatch()
	const { product } = useProduct()
	const { ID, PRICE } = product
	const { getBasketItem, deleteItem } = useCart()
	const cartItemData = useMemo(() => getBasketItem(ID), [getBasketItem, ID])
	const filterItems = useGetRelatedProducts(ID).filter(item => item.TYPE_PRODUCTS === ProductType.Service)

	if (!filterItems.length) return null

	// Total price accumulator
	const totalPrice: number = PRICE.VALUE * (cartItemData ? cartItemData.QUANTITY : 1)

	const onDeleteItemClick = (
		basketId: number,
		productId: number,
		isRelatedProductInCart: boolean,
		isAcsProduct: boolean
	) => {
		if (isRelatedProductInCart || isAcsProduct) {
			deleteItem(basketId, productId)
		} else {
			const removedProduct = filterItems.find(product => product.ID === productId)

			dispatch(removeItemInLocalList(removedProduct))
		}
	}

	return (
		<section className={cl.section}>
			<ul className={cl.list} aria-label="Список дополнительных элементов к товару">
				{/* Total */}
				{!!totalPrice && (
					<TotalProductSetItem
						item={{
							TITLE: `Итог`,
							PRICE: { VALUE: totalPrice < 0 ? 0 : totalPrice, PRICE_TYPE: `` },
							TYPE_PRODUCTS: ItemTypes.Total
						}}
						ID={ID}
						relatedItems={filterItems}
						onDeleteClick={onDeleteItemClick}
						hidePrice={hidePrice}
					/>
				)}
			</ul>
		</section>
	)
}
